/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

const visualViewer = {
  contentType: {
    drawing2D: '2D',
    model3D: '3D',
  },
  toolbar: {
    homeButton: { label: 'Hogar' },
    zoomButton: { label: 'Zoom' },
    panButton: { label: 'Cacerola' },
    rotateButton: { label: 'Rotar' },
    isolateButton: { label: 'Aislar' },
    playButton: { label: 'Jugar' },
    pauseButton: { label: 'Pausa' },
    hotspotsButton: { label: 'Hotspots', show: 'Show', hide: 'Ocultar' },
    visualViewerAnimationSlider: {
      label: 'Control deslizante de animación',
      role: 'Slider',
    },
  },
};

const visualPicking = {
  visualPickingTab: {
    noProductReferences: 'No hay piezas de repuesto disponibles para este producto.',
  },
  visualPickingProductList: {
    description: 'Descripción',
    itemPrecio: 'Precio',
    outOfStock: 'Agotado',
    id: 'IDENTIFICACIÓN',
  },
  visualPickingProductFilter: {
    input: {
      placeholder: 'Filtrar por nombre o id',
    },
    buscarButton: {
      label: 'buscar',
    },
    restablecimientoButton: {
      label: 'restablecimiento',
    },
  },
};

const errors = {
  visualLoad: {
    noMatchingVisualFound: 'No se encontró ninguna visualización coincidente',
    multipleMatchingVisualsFound: 'Se han encontrado varias visualizaciones coincidentes',
    unexpectedLoadError: 'Se ha producido un error al cargar la visualización',
  },
};

export const epdVisualization = {
  epdVisualization: {
    visualViewer,
    visualPicking,
    errors,
  },
};
